import {AxiosInstance, AxiosRequestConfig, AxiosResponse} from "axios";
import store from "@/store";

export const memberAuthDataExpiredInterceptor = (instance: AxiosInstance) => instance.interceptors.response.use(
    function (response: AxiosResponse) {
      if (response.data.code === 4444) {
        // 토큰이 만료되어 의미가 없어졌으므로 삭제
        store.commit('MemberStore/removeMemberAuthData');
      }
      return response;
    },
);